import * as React from 'react';
export var IconChevronLeft = React.forwardRef(function IconChevronLeft({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M9.759 4.198a.75.75 0 0 1 .042 1.06L7.271 8 9.8 10.74a.75.75 0 1 1-1.1 1.02l-3-3.25a.75.75 0 0 1 0-1.018l3-3.25a.75.75 0 0 1 1.06-.043Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M13.738 6.183a.75.75 0 0 1 .081 1.058L9.74 12l4.084 4.762a.75.75 0 1 1-1.138.976l-4.504-5.25a.75.75 0 0 1 0-.976l4.5-5.248a.75.75 0 0 1 1.057-.08Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M13.738 6.183a.75.75 0 0 1 .081 1.058L9.74 12l4.084 4.762a.75.75 0 1 1-1.138.976l-4.504-5.25a.75.75 0 0 1 0-.976l4.5-5.248a.75.75 0 0 1 1.057-.08Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
